module.exports = __webpack_public_path__ + "static/img/codeiocn3.fb46cb3a.svg";